export const SET_UNREAD_MESSAGES = 'SET_UNREAD_MESSAGES';
export const ADD_UNREAD_MESSAGE = 'ADD_UNREAD_MESSAGE';
export const REMOVE_UNREAD_MESSAGES = 'REMOVE_UNREAD_MESSAGES';
export const SET_MESSAGE_READ_DATETIME = 'SET_MESSAGE_READ_DATETIME';
